// 判断对象
function isObject(obj) {
  return Object.prototype.toString.call(obj) === "[object Object]";
}

// 判断数组
function isArray(arr) {
  return Array.isArray(arr);
}

//时间戳转时间
function timestampToTime(time) {
  // 获取年份、月份、小时、分钟和秒
  const year = time.getFullYear(); // 获取四位年份
  const month = String(time.getMonth() + 1).padStart(2, '0'); // 月份从0开始，补零
  const hours = String(time.getHours())
  const day = String(time.getDate()).padStart(2, '0'); // 补零
  const minutes = String(time.getMinutes()).padStart(2, '0'); // 补零
  const seconds = String(time.getSeconds()).padStart(2, '0'); // 补零
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

//时间戳转时间h:ss
function timestampToHss(v) {
  const time = new Date(v);
  const hours = String(time.getHours())
  const minutes = String(time.getMinutes()).padStart(2, '0'); // 补零
  const seconds = String(time.getSeconds()).padStart(2, '0'); // 补零
  return `${hours}:${minutes}:${seconds}`;
}

// 深拷贝
function deepCopy(val) {
  if ([null, undefined].includes(val)) return val;
  let temp = '';
  if (isArray(val)) {
    temp = [];
    val.forEach(item => temp.push(deepCopy(item)));
  } else if (isObject(val) && !(val instanceof Date)) {
    temp = {};
    Object.keys(val).forEach(key => (temp[key] = deepCopy(val[key])));
  } else {
    temp = val;
  }
  return temp;
}

/**
 * value值转换为label，（满足数据格式，数组，切数组中的元素为对象）
 * @param {String} pro 需要转换的数组对象属性
 * @param {Array[Object]} arr 需要转换的数组
 * @param {Array[Object]} dictionaryArr 转换的数据字典数据（对象中含 value 和 label 属性）
 */
function valueToLabel(pro, arr, dictionaryArr) {
  for (let i = 0; i < arr.length; i++) {
    for (let j = 0; j < dictionaryArr.length; j++) {
      if (arr[i][pro] === dictionaryArr[j].value) {
        arr[i][pro] = dictionaryArr[j].label
      }
    }
  }
  return arr
}

/**
 * 生成随机字符串
 * @param {*} length 需要生成的字符串长度
 * @returns
 */
function generateRandomString(length) {
  const characters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
}

export {
  isObject,
  isArray,
  deepCopy,
  valueToLabel,
  timestampToTime,
  timestampToHss,
  generateRandomString,
}



// WEBPACK FOOTER //
// ./src/utils/tools.js